import { QqModel } from "../../model/qq.model";
import { QqActionType, SLIDER_CHANGED_ACTION } from "../qq-action.type";

export const sliderAction: (qq: QqModel, position: number) => QqActionType = (
  qq,
  position
) => {
  return {
    type: SLIDER_CHANGED_ACTION,
    data: {
      qq,
      position,
    },
  };
};
